<main>
  <div *ngIf="resume" class="bulb-resume-view row small-collapse resume-grid-container">

    <!-- Contact details component -->
    <div class="bulb-resume-contact-details" data-obsvr-root="data-obsvr-root">
      <bulb-resume-contact-details *ngIf="user"
                     [resume]="resume"
                     (updateResume)="updateResume($event)"
                     [user]="user"
                     [canEdit]="canEdit">
      </bulb-resume-contact-details>
    </div>

	  <!-- Resume Overlay Div -->
	  <div class="resume-section-overlay"></div>

	  <!-- Resume Content Container -->
    <div class="bulb-resume-content-container">
      <ng-container #comps></ng-container>
      <div class="drag-line drop-end" pDroppable="section" (onDrop)="drop('dragLast')"></div>
      <button *ngIf="canEdit && showCustomButtonDropdown" (click)="addNewCustomSection()" class="bulb-resume-add-custom-btn">
        <i class="fal fa-plus"></i>
        <p class="bulb-add-content-text" transloco="resume.add.section">Add A Section</p>
      </button>

      <bulb-menu-list-panel [positionCenter]='true' *ngIf="!showCustomButtonDropdown" [menuItems]="createMenuItems" class="section-width" >
        <ng-template #buttonTemplate>
          <button *ngIf="canEdit" #toggleEl  class="bulb-resume-add-custom-btn">
            <i class="fal fa-plus"></i>
            <p class="bulb-add-content-text" transloco="resume.add.section">Add A Section</p>
          </button>
        </ng-template>
      </bulb-menu-list-panel>
    </div>
  </div>
</main>
